import React from 'react';
import { Navigate } from 'react-router-dom';
import { usePermissions } from '../contexts/PermissionContext';
import { CircularProgress, Box, Typography } from '@mui/material';

const ProtectedRoute = ({ 
  children, 
  requiredPermission, 
  requiredRole, 
  requiredModule,
  fallbackPath = '/panel/dashboard' 
}) => {
  const { 
    hasPermission, 
    hasRole, 
    canAccessModule, 
    loading, 
    error 
  } = usePermissions();

  // Show loading while permissions are being fetched
  if (loading) {
    return (
      <Box 
        display="flex" 
        flexDirection="column" 
        alignItems="center" 
        justifyContent="center" 
        minHeight="200px"
      >
        <CircularProgress color="primary" />
        <Typography variant="body2" sx={{ mt: 2 }}>
          Yetkiler kontrol ediliyor...
        </Typography>
      </Box>
    );
  }

  // Show error if permission fetch failed
  if (error) {
    return (
      <Box 
        display="flex" 
        flexDirection="column" 
        alignItems="center" 
        justifyContent="center" 
        minHeight="200px"
      >
        <Typography variant="h6" color="error">
          Yetki bilgileri alınamadı
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {error}
        </Typography>
      </Box>
    );
  }

  // Check specific permission
  if (requiredPermission && !hasPermission(requiredPermission)) {
    return <Navigate to={fallbackPath} replace />;
  }

  // Check specific role
  if (requiredRole && !hasRole(requiredRole)) {
    return <Navigate to={fallbackPath} replace />;
  }

  // Check module access
  if (requiredModule && !canAccessModule(requiredModule)) {
    return <Navigate to={fallbackPath} replace />;
  }

  return children;
};

export default ProtectedRoute;
